import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import Default from './Default';
import IndexBar from '../layout/IndexBar';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import gsap from 'gsap';
import { isSmartphone } from '../_app/cuchillo/core/Basics';

export default class Report extends Default {
  constructor() {
    super();

    const nav = GetBy.selector('.report-nav', this.container)[0]
      || GetBy.selector('.page-report__index', this.container)[0];
    const holder = GetBy.selector('.page-report__holder', this.container)[0]
      || this.container;
    const indexContent = GetBy.selector('.report-nav__content', this.container)[0];
    this._isIndexOpen = false;

    if(isSmartphone) indexContent.setAttribute('hidden', true);

    this.indexNav = nav ? new IndexBar(nav, holder) : null;
    this.indexButton = GetBy.selector('[data-open-index] span', this.container)[0];

    Interaction.addListener('data-open-index', (_e) => {
        if(this._isIndexOpen) {
          this.indexButton.textContent = 'Index';
            this._isIndexOpen = false;
            gsap.to(indexContent, {
              duration: 0.1,
              opacity: 0,
              delay: 0,
              ease: 'power2.in',
          });
            gsap.to(indexContent, {
                duration: 0.4,
                ease: 'power2.Out',
                y: "-80%",
                onComplete: () => {
                  indexContent.setAttribute('hidden', true);
                }
            });
        } else {
          this.indexButton.textContent = 'Close';
          
            this._isIndexOpen = true;
            indexContent.removeAttribute('hidden');
            gsap.to(indexContent, {
                duration: 0.1,
                opacity: 1,
                delay: 0.02,
                ease: 'power2.in',
            });
            gsap.to(indexContent, {
                duration: 0.2,
                ease: 'power2.Out',
                y: "-100%",
            });
        }
        //indexContent.classList.toggle('--hidden');
    }, "ReportIndex");
  }

  afterShow() {
    super.afterShow();
    // Tras Scroll.init (+100ms items), recalcular anchors
    requestAnimationFrame(() => {
      this.indexNav?.reset();
    });
  }

  afterHide() {
    this.indexNav?.dispose();
    this.indexNav = null;
    super.afterHide();
  }

  resize() {
    super.resize();
    this.indexNav?.resize();
  }

  dispose() {
    Interaction.removeListener("ReportIndex");
    super.dispose();
  }

  loop() {
    if (!this._isActive) return;
    super.loop();
    this.indexNav?.loop();
  }
}

ControllerPage._addPage('report', Report);
